import React, { useId } from 'react';
import { Check, X } from 'lucide-react';
import { APPLICATION_STAGES, getApplicationProgress } from '../../utils/applicationStatusModel';
import './ApplicationProgress.css';

const ApplicationProgress = ({ status, className = '', showOutcome = true }) => {
  const headingId = useId();
  const progress = getApplicationProgress(status);

  return (
    <section className={`application-progress ${className}`} aria-labelledby={headingId} data-status={status || 'unknown'}>
      <h2 id={headingId}>What happens next</h2>
      <ol className="application-progress-steps">
        {APPLICATION_STAGES.map((stage, index) => {
          const completed = index < progress.completed;
          const current = index === progress.current;
          const state = current ? 'current' : completed ? 'completed' : ['inactive', 'unknown'].includes(progress.tone) ? 'unavailable' : 'pending';
          const decisionTone = index === 2 && completed ? progress.tone : '';
          return (
            <li key={stage.title} className={`application-progress-step ${state} ${decisionTone}`} aria-current={current ? 'step' : undefined} data-state={state}>
              <span className="application-progress-marker" aria-hidden="true">
                {completed && (decisionTone === 'negative' ? <X size={20} /> : <Check size={20} />)}
              </span>
              <div className="application-progress-copy">
                <p className="application-progress-title"><span aria-hidden="true">0{index + 1}</span>{stage.title}</p>
                <p className="application-progress-description">{stage.description}</p>
                <span className="sr-only">{current ? 'Current stage' : completed ? 'Completed' : state === 'unavailable' ? 'Not available' : 'Pending'}</span>
              </div>
            </li>
          );
        })}
      </ol>
      {showOutcome && progress.message && (
        <p className={`application-progress-outcome ${progress.tone}`}>
          <strong>{progress.label}.</strong> {progress.message}
        </p>
      )}
    </section>
  );
};

export default ApplicationProgress;
